export default "/images/vendor/flag-icon-css/flags/1x1/dg.svg?0daff5bf1376fa8759b9770151d03f46";